module.exports = __webpack_public_path__ + "img/wrapbg8.1dca21f3.png";